"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeKeys = exports.camelKeys = void 0;
var snakeCase_1 = __importDefault(require("lodash-es/snakeCase"));
var camelCase_1 = __importDefault(require("lodash-es/camelCase"));
var isObject_1 = __importDefault(require("lodash-es/isObject"));
var isArray_1 = __importDefault(require("lodash-es/isArray"));
var reduce_1 = __importDefault(require("lodash-es/reduce"));
var camelKeys = function (data) {
    return changeCase(data, camelCase_1.default);
};
exports.camelKeys = camelKeys;
var snakeKeys = function (data) {
    return changeCase(data, snakeCase_1.default);
};
exports.snakeKeys = snakeKeys;
var changeCase = function (data, transform) {
    if (!(0, isObject_1.default)(data) || data instanceof Date) {
        return data;
    }
    if ((0, isArray_1.default)(data)) {
        return data.map(function (v) { return changeCase(v, transform); });
    }
    return (0, reduce_1.default)(data, function (r, v, k) {
        var _a, _b;
        // this is for product details which should not be transformed!
        if (k === "details") {
            return __assign(__assign({}, r), (_a = {}, _a[k] = v, _a));
        }
        return __assign(__assign({}, r), (_b = {}, _b[transform(k)] = changeCase(v, transform), _b));
    }, {});
};
